import { render, staticRenderFns } from "./OrdersSummary.vue?vue&type=template&id=23225076&scoped=true&"
import script from "./OrdersSummary.vue?vue&type=script&lang=js&"
export * from "./OrdersSummary.vue?vue&type=script&lang=js&"
import style0 from "./OrdersSummary.vue?vue&type=style&index=0&id=23225076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23225076",
  null
  
)

export default component.exports